import { render, staticRenderFns } from "./SupplyBoatPricingForm.vue?vue&type=template&id=660f0fc4&"
import script from "./SupplyBoatPricingForm.vue?vue&type=script&lang=js&"
export * from "./SupplyBoatPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports